import { TooltipParagraph } from "components/tooltipParagraph";
import { IEventTickets } from "interfaces";
import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";

interface EventTicketsTableProps {
  data?: IEventTickets[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  currency?: string;
}

export const EventTicketsTable = ({data = [], isLoading, currentPage, pageSize, currency }: EventTicketsTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th
                scope="col"
                className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
              >
                No
              </th>
              <th scope="col" className="th">
                Ticket name
              </th>
              <th scope="col" className="th">
                Phase
              </th>
              <th scope="col" className="th">
                Price
              </th>
              <th scope="col" className="th">
                Items
              </th>
              <th scope="col" className="th">
                Gross revenue
              </th>
              <th scope="col" className="th">
                Discount
              </th>
              <th scope="col" className="th">
                Net revenue
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
          {(!isLoading) ? data.map((item: IEventTickets, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.name_en}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td overflow-x-auto capitalize">
                  {item.ticket_phase_name_en}
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.price)}
                  >
                    {currencySymbol(currency)} {abbreviateNumbers(item.price)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.quantity)}
                  >
                    {abbreviateNumbers(item.quantity)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.gross_revenue)}
                  >
                    {currencySymbol()} {abbreviateNumbers(item.gross_revenue)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.discount_amount)}
                  >
                    {currencySymbol()} {abbreviateNumbers(item.discount_amount)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.net_revenue)}
                  >
                    {currencySymbol()} {abbreviateNumbers(item.net_revenue)}
                  </span>
                </td>
              </tr>
            )) 
            : Array(10).fill(null).map((item: any, index: number) => (
              <tr key={index} className="h-[57px]">
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td max-w-40 overflow-x-auto">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
              </tr>
            ))}
            {data.length === 0 && !isLoading ? (
              <tr>
                <td colSpan={10} className="td">
                  <div className="text-center">
                    No data
                  </div>
                </td>
              </tr>
            ) : <></>}
          </tbody>
        </table>
      </div>

    </div>

  )
}